// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f435d6a1","404":"0ec6129f","787":"701c8e0c"}[chunkId] + ".chunk.js";
};